import { Component, EventEmitter, Input, OnInit, OnDestroy, Output} from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService} from 'shared-components';
import { CultivosService } from '../../../../services/cultivos.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { formatDate } from "@angular/common";

@Component({
    selector: 'app-cultivo-designacion',
    templateUrl: './cultivo-designacion.component.html'
})
export class CultivoDesignacionComponent implements OnInit, OnDestroy {

  public newForm: UntypedFormGroup;
  public showError: boolean;

  private readonly destroy$ = new Subject<void>();

  private _desginacion;
  public designacionId;

  public marcaId;
  public cultivo;
  public almacenes;
  public almacenesAsociados = [];
  public aforoDisponible;
  public oldKilosADesignar;
  public oldAforoDisponible;
  public porcentajeAforoDisponible = 0;
  public designaciones = [];
  public etiquetadores = [];
  public toCloseSpinner = 0;

  public showAlmacenes = false;
  public capacidadModal = false;
  public deleteModal = false;
  public disabledEtiquetadores: Subject<boolean> = new Subject();
  public mensajes = new Array<Message>();

  @Input() set cultivoDesignacion(cultivo: any) {
    if (cultivo) {
      this.cultivo = cultivo;
      this.newForm.get('denominacion').patchValue(cultivo.desDenominacionCampanya);
      this.newForm.get('finca').patchValue(cultivo.desFinca);
      this.newForm.get('superficie').patchValue(cultivo.superficie);
      this.newForm.get('nPlantas').patchValue(cultivo.nPlantas);
      this.newForm.get('aforo').patchValue(cultivo.aforo);
      this.newForm.get('aforoDisponible').patchValue(cultivo.aforoDisponible);
      this.oldAforoDisponible = cultivo.aforoDisponible;
      this.aforoDisponible = cultivo.aforoDisponible;
      this.marcaId = cultivo.marcaId ? cultivo.marcaId : null;
      this.oldKilosADesignar = 0;
      this.porcentajeAforoDisponible = (cultivo.aforoDisponible / cultivo.aforo) * 100;
      this.getEtiquetadoresByDenominacionId();
    }
  }

  @Output() refresh = new EventEmitter<boolean>();
  @Output() mensaje = new EventEmitter<string>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _translate: TranslateService,
    private readonly _spinnerService: SpinnerService,
    private readonly _cultivosService: CultivosService,
    private readonly _sessionContext: SessionContextService
  ) {
    this.newForm = this._fb.group({
      fechaDesignacion: [{ value: '' }, Validators.required],
      denominacion: [{ value: '', disabled: true }],
      finca: [{ value: '', disabled: true }],
      superficie: [{ value: '', disabled: true }],
      nPlantas: [{ value: '', disabled: true }],
      aforo: [{ value: '', disabled: true }],
      aforoDisponible: [{ value: '', disabled: true }],
      cantidad: [{ value: '', disabled: false }, Validators.required],
      etiquetador: ['', Validators.required],
      almacenes: [{ value: true, disabled: true }, Validators.required],
    });

    this.newForm.patchValue({
      fechaDesignacion: new Date()
    });
  }

  ngOnInit() {
    this.newForm.get('cantidad').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((kilos) => {
      if (!this.newForm.get('cantidad').pristine) {
        this.newForm.get('aforoDisponible').setValue(this.aforoDisponible + (this.oldKilosADesignar - kilos));
        this.porcentajeAforoDisponible = (this.newForm.get('aforoDisponible').value / this.newForm.get('aforo').value) * 100;
      }
    });

    this.newForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
      if (etiquetador) {
        let _filtersAlmacenes = {
          etiquetadorId: etiquetador.id
        };

        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getAlmacenesByEtiquetador(_filtersAlmacenes).toPromise().finally(() => {
          this.checkCloseSpinner();
        }).then((resp) => {
          this.almacenes = resp.lista;
          if (resp.lista.length >= 2) {
            this.newForm.get('almacenes').enable();
          } else {
            this.newForm.get('almacenes').patchValue(true);
            this.newForm.get('almacenes').disable();
          }
        });
      } else {
        this.almacenes = null;
        this.almacenesAsociados = [];
        this.newForm.get('almacenes').patchValue(true);
        this.newForm.get('almacenes').disable();
      }
    });

    this.newForm.get('almacenes').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((almacen) => {
      if (almacen === false) {
        this.showAlmacenes = true;
      } else {
        this.showAlmacenes = false;
        this.almacenesAsociados = [];
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public getEtiquetadoresByDenominacionId() {
    let filters = {
      denominacionId: this.cultivo.denominacionIdCampanya,
      paisId: this.cultivo.paisIdCampanya
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._cultivosService.getEtiquetadoresByDenominacionId(filters).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      if (resp.lista.length > 0) {
        this.etiquetadores = resp.lista;
        this.newForm.get('etiquetador').enable();
        this.disabledEtiquetadores.next(false);
      } else {
        this.newForm.get('etiquetador').disable();
        this.disabledEtiquetadores.next(true);
      }
    });
  }

  public addAlmacenes(event: any) {
    if (event.target.checked) {
      this.almacenesAsociados.push(event.target.id);
    } else {
      const index = this.almacenesAsociados.indexOf(event.target.id);
      if (index > -1) {
        this.almacenesAsociados.splice(index, 1);
      }
    }
  }

  public insertar() {
    this.checkForm();
    if (this.newForm.valid && !this.showError) {
      if (this.newForm.get('cantidad').value > this.aforoDisponible ) {
        this.capacidadModal = true;
      } else {
        this.addDesignacion();
      }
    }
  }

  public addDesignacion() {
    this.mensajes = [];
    this.capacidadModal = false;
    this._desginacion = {
      cultivoId: this.cultivo.id,
      marcaId: this.marcaId,
      etiquetadorId: this.newForm.get('etiquetador').value.id,
      fecha: formatDate(this.newForm.get('fechaDesignacion').value, 'yyyy-MM-dd', 'en-GB'),
      cantidad: this.newForm.get('cantidad').value,
      lsAlmacenId: this.newForm.get('almacenes').value ? null : this.almacenesAsociados
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._cultivosService.createDesignacion(this._desginacion).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      if (resp.id) {
        this.pushMessage('global.success.itemCreated');
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getDesignacion(resp.id).toPromise().finally(() => {
          this.checkCloseSpinner();
        }).then((resp) => {
          this.newForm.get('cantidad').reset();
          this.aforoDisponible = this.aforoDisponible - this._desginacion.cantidad;
          this.newForm.get('aforoDisponible').patchValue(this.aforoDisponible);
          this.designaciones.push(resp);
        });
      } else {
        this.showError = true;
        this.pushMessage('global.error.noResponse');
      }
    },
    (error) => {
      this.showError = true;
      let message;
      if (error.status === 420) {
        switch (error.error.ApiErrorCode) {
          case 6073:
            message = this._translate.instant('ApiErrors.fechaFueraDeCampanya');
            break;
          case 3000: // FuncionalidadRestringida
            message = this._translate.instant('ApiErrors.funcionalidadRestringida');
            break;
          case 3014: // EtiquetadorNoAccesible
            message = this._translate.instant('ApiErrors.etiquetadorNoAccesible');
            break;
          case 5100: // CultivoNoAccesible
            message = this._translate.instant('ApiErrors.cultivoNoAccesible');
            break;
          case 6005: // FincaPruebaOpAdmin
            message =  this._translate.instant('ApiErrors.fincaPruebaOpAdmin');
            break;
          case 6006: // CultivoNoAccesibleParaEtiquetadorSeleccionado
            message = this._translate.instant('ApiErrors.cultivoNoAccesibleParaEtiquetadorSeleccionado');
            break;
          case 6036: // CampanyaNoHabilitada
            message = this._translate.instant('ApiErrors.campanyaHabilitada');
            break;
          case 6007: // MarcaPaisDenominacionNoAccesible
            message = this._translate.instant('ApiErrors.marcaPaisDenominacionNoAccesible');
            break;
          case 6008: // CultivoMarcaNoAccesible
            message = this._translate.instant('ApiErrors.cultivoMarcaNoAccesible');
            break;
          case 6009: // MarcaPaisDenominacionNoAccesibleParaEtiquetadorSeleccionado
            message = this._translate.instant('ApiErrors.marcaPaisDenominacionNoAccesibleParaEtiquetadorSeleccionado');
            break;
          case 6166: // EtiquetadorCampanyaInactiva - solo insert
            message = this._translate.instant('ApiErrors.etiquetadorCampanyaInactiva');
            break;
          case 4007: // FluentValidationGenerico
            message = this._translate.instant('ApiErrors.fluentValidationGenerico');
            break;
          case 5101: // DesignacionNoAccesible
            message = this._translate.instant('ApiErrors.designacionNoAccesible');
            break;
          case 5103: // AlmacenNoAccesible
            message = this._translate.instant('ApiErrors.almacenNoAccesible');
            break;
          case 6074: // DesignacionAlmacenYaExiste
            message = this._translate.instant('ApiErrors.designacionAlmacenYaExiste');
            break;
          case 6097: // DesignacionAlmacenDiferenteEtiquetador
            message = this._translate.instant('ApiErrors.designacionAlmacenDiferenteEtiquetador');
            break;
          default:
            message = this._translate.instant('ApiErrors.serverError');
            break;
        }
      } else {
        message = this._translate.instant('ApiErrors.serverError');
      }
      this.mensajes.push({ class: 'warning', message: message });
    });
  }

  private checkForm() {
    this.showError = this.newForm.invalid;
    if (this.showError) {
      this.pushMessage('global.error.required');
    }
  }

  public pushMessage(mensaje) {
    if (mensaje.includes('req') || mensaje.includes('ApiErrors')) {
      this.mensajes.push({ class: 'error', message: mensaje });
    } else if (mensaje.includes('Cre')) {
      this.mensajes.push({ class: 'success', message: mensaje });
    } else if (mensaje.includes('noR')) {
      this.mensajes.push({ class: 'error', message: mensaje });
    } else if (mensaje.includes('Del')) {
      this.mensajes.push({ class: 'success', message: mensaje });
    }
  }

  public askDelete(designacion) {
    this.designacionId = designacion.id;
    this._desginacion = designacion;
    this.deleteModal = true;
  }

  public delete() {
    this._spinnerService.showSpinner();
    const index = this.designaciones.indexOf(this._desginacion);
    if (index > -1) {
      this.designaciones.splice(index, 1);
    }
    this._cultivosService.deleteDesignacion(this.designacionId).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then(() => {
      this.deleteModal = false;
      this.aforoDisponible = this.aforoDisponible + this._desginacion.cantidad;
      this.newForm.get('aforoDisponible').patchValue(this.aforoDisponible);
      this.porcentajeAforoDisponible = (this.newForm.get('aforoDisponible').value / this.newForm.get('aforo').value) * 100;
      this.pushMessage('global.success.itemDeleted');
    });
  }

  private checkCloseSpinner() {
    this.toCloseSpinner -= 1;
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public close() {
    if (this.designaciones.length > 0) {
      this.refresh.emit(true);
    } else {
      this.refresh.emit(false);
    }
  }

  public trackByDesignacionId(index: number, designacion: { id: number }): number {
    return designacion.id;
  }
}
